var ImageBarManager = new Class({
    Implements : [Options],
    ImplementObserver: GS.Observer,
    userImages : [],
    userLayoutsImages: [],
    layoutWaitingForImport: [],
    defaultImages : [],
    binds : {},
    options : {
        thumb_el : [],
        startAtIndex : 0,
        deleteButton : '.remove',
        'counterEl' : null,
        extraDropZones : []
    },
    loadingQueue : [],
    maxCuncurrent : 20,
    loading : 0,
    loadedImages : 0,
    activeTab: null,
    initialize : function(options) {
        'use strict';

        this.setOptions(options);
        switch (typeof this.options.thumbContainer) {
            case "undefined":
                throw "Undefined thumbContainer";
            case "string":
                this.options.thumbContainer = document.querySelector(this.options.thumbContainer);
                break;
            case "object":
                break;
            default:
                throw "Unsupported type";
        }

        //console.warn(this.options);

        if ( typeof this.options.thumbContainer !== "object") {
            throw "ImageContainer not found";
        }
        this.addListeners();
        this.initializeThumbnailsCommands();
    },
    addListeners : function() {
        'use strict';
        var self = this;

        window.addEvent('current:bottomtab',function(selTab){
            //console.warn('CURRENT BOTTOM TAB IS', selTab, selTab.indexOf('layouts'));
            this.activeTab = selTab;
            //console.warn('CURRENT ACTIVE TAB: %s', selTab);
        }.bind(this));

        this.binds.updateImageUsage = this.updateImageUsage.bind(this);
        window.addEvent('images:updateImageUsage',this.binds.updateImageUsage);
        this.binds.deleteSelection = this.deleteSelection.bind(this);
        if ( typeof this.options.onImageDropOnContainer === "function" && this.options.thumbContainer){
            this.options.thumbContainer.addEventListener('dragenter',function(evt){
                evt.preventDefault();
                self.options.onImageDropOnContainer.call(self,evt);
            });
            this.options.extraDropZones.forEach(function(element){
                if(element){
                    element.addEventListener('dragover',function(evt){
                        evt.preventDefault();
                        self.options.onImageDropOnContainer.call(this,evt);
                    });
                }
            },self);
        }
        /*
        if(this.options.thumbContainerLayouts){
            this.options.thumbContainerLayouts.addEventListener('dragenter',function(evt){
                evt.preventDefault();
                if (evt.dataTransfer.types) {
                    if(evt.dataTransfer.types.indexOf('Files') !== -1) {
                        uploadFMVar.showLayouts(true);
                    }
                }
            });

            this.options.extraDropZones.forEach(function(element){
                if(element){
                    element.addEventListener('dragover',function(evt){
                        if(!self || self.activeTab !== '#pageLayouts') return;
                        evt.preventDefault();
                        if (evt.dataTransfer.types) {
                            if(evt.dataTransfer.types.indexOf('Files') !== -1) {
                                uploadFMVar.showLayouts(true);
                            }
                        }
                    });
                }
            },self);
        }
        */
        /*
        if(this.options.thumbContainerLogos){
            this.options.thumbContainerLogos.addEventListener('dragenter',function(evt){
                evt.preventDefault();
                if (evt.dataTransfer.types) {
                    if(evt.dataTransfer.types.indexOf('Files') !== -1) {
                        uploadFMVar.showLogos();
                    }
                }
            });

            this.options.extraDropZones.forEach(function(element){
                if(element){
                    element.addEventListener('dragover',function(evt){
                        console.warn('ACTIVE TAB', self.activeTab);
                        if(!self || self.activeTab !== '#pageLayouts') return;
                        return;
                        evt.preventDefault();
                        if (evt.dataTransfer.types) {
                            if(evt.dataTransfer.types.indexOf('Files') !== -1) {
                                uploadFMVar.showLogos();
                            }
                        }
                    });
                }
            },self);
        }
        */
    },
    createThumbnail : function(uuid,initialLoad, type) {
        'use strict';
        var mainEl = this.options.thumbContainer;
        var tab, onPage, asLayout;
        var tImportIn = 0;
        switch(type){
            case 'logos':
                //tab = document.querySelector('#imported_pages');
                mainEl = this.options.thumbContainerLogos;
                break;
            case 'layouts':
                tab = document.querySelector('#imported_pages');
                mainEl = this.options.thumbContainerLayouts;
                if(tab) tab.style.display = '';
                break;
        }
        //console.warn('CREATING NEW THUMBNAIL OF TYPE: %s', type);
        var template = document.getElementById('thumbnailsTemplate');
        if (mainEl.querySelector('.fi-upload')){
            mainEl.innerHTML = "";
        }
        var thumbEl = template.content.querySelector("div");
        thumbEl.dataset.uuid=uuid;
        thumbEl.dataset.type=type;
        thumbEl.dataset.afterAction = type;

        thumbEl.store('type', type);
        thumbEl.classList.add('loading');



        //thumbEl.setAttribute('title', )
        if(!initialLoad)
            thumbEl.dataset.image_status="uploading";

        else
            thumbEl.dataset.image_status="upload_complete";

        mainEl.appendChild(template.content.cloneNode(true));

        //console.warn(thumbEl);
        thumbEl = mainEl.querySelector("[data-uuid='"+uuid+"']");

        //
        thumbEl.querySelector(this.options.deleteButton).addEventListener('click',function(evt){
            console.warn('DELETE IMAGE', this.options.onImageDelete);
            evt.stopPropagation();
            if ( typeof this.options.onImageDelete === "function"){
                this.options.onImageDelete(evt);
            }
        }.bind(this));


        this.userImages.some(function(img){
            if(img.uuid === uuid){
                thumbEl.setAttribute('title', (img.original_name ? img.original_name : img.originalName ? img.originalName : '').replace(/"/gim,'/"'));
            }
            return img.uuid === uuid;
        });

        if(type !== 'layouts'){
            thumbEl.addEventListener('click', function(e){
                if(!this.imageData) return;
                this.classList.toggle('selected');
            });
            thumbEl.dataset.importIn = mainEl.children.length - 1;
            onPage = thumbEl.querySelector('[data-type="page"]');
            asLayout = thumbEl.querySelector('[data-type="layout"]');

            if(onPage){

                /*(function(thumbEl){
                    this.addEvent('update:spreads', function(){
                        console.warn('UPDATE SPREADS LIST, SET IMPORT IN: %s', thumbEl.dataset.importIn, this.spreads);
                    });
                }).call(this, thumbEl);*/


            }

            if(asLayout){
                asLayout.addEventListener('change', function (ev){
                    console.warn('SET IMPORT LAYOUT TO:', this.value, thumbEl.dataset.importIn);
                });
            }
        }


        this.resize();
    },

    addImagesToUserImages : function(images, type){
        'use strict';
        console.warn('ADD IMAGE TO USER: TYPE IS %s', type, images);
        switch(type){
            case 'logos':

                this.userLogoImages = this.userLogoImages.concat(images);

                break;
            case 'layouts':
                this.userLayoutsImages = this.userLayoutsImages.concat(images);
                this.check4SpreadChanges();
                break;
            default:
                this.userImages = this.userImages.concat(images);
                break;
        }
    },
    updateImageUsage : function(conf){
        'use strict';
        if(conf.old_image_id){
            var _old_el = document.querySelector('[data-imageid="'+conf.old_image_id+'"]');
            if(_old_el){
                var _old_counter = _old_el.querySelector(".used_count");
                var oldUsed = parseInt(_old_counter.innerHTML);
                oldUsed = Math.max(--oldUsed,0);
                _old_counter.innerHTML = oldUsed;
                if(oldUsed == 0){
                    _old_counter.removeClass('used_image');
                    _old_el.querySelector('.remove').show();
                }
            }
        }
        if(conf.new_image){
            var newEl = document.querySelector('[data-imageid="'+conf.new_image+'"]');
            if(newEl){
                var countEl = newEl.querySelector('.used_count');
                var newUsed = parseInt(countEl.innerHTML);
                countEl.set('html',++newUsed);
                if(newUsed > 0 && !countEl.classList.contains('used_image')){
                    countEl.addClass('used_image');
                    newEl.querySelector('.remove').hide();
                }
            }
        }
    },
    deleteSelection : function(){

    },
    addImageEvents : function(image) {
        'use strict';
        image.ondragstart = function(e) {
            e.dataTransfer.setData('type','thumbnail');
            e.dataTransfer.setData('data',JSON.encode(this.retrieve('data')));
            e.dataTransfer.setData('text', this.url);
            e.dataTransfer.setData("image-thumbnail",true);
        };
    },

    checkForLoadingThumbs: function(container, type){
        var progressContainer;
        var childer = container.children;
        var keepWaitingPreviewLabel = false;
        keepWaitingPreviewLabel = Array.prototype.some.call(childer, function(thumb){
            return thumb.classList.contains('loading');
        });

        if(!keepWaitingPreviewLabel){
            switch(type){
                case 'logos':
                    progressContainer = document.querySelector('label[for="tab-3"] .upload_progress');
                    break;
                case 'layouts':
                    progressContainer = document.querySelector('#Layouts .upload_progress');
                    break;
                default:
                    progressContainer = document.querySelector('[for="tab-1"] .upload_progress'); //CASE WALL ART
                    if(!progressContainer) progressContainer = document.querySelector('#Photos .upload_progress');
                    break;
            }

            if(progressContainer) progressContainer.innerHTML = '';
        }
        //console.warn('KEEP WAITING FOR THUMBNAIL PREVIEW LABEL? %s', keepWaitingPreviewLabel);
    },

    updateThumbnailAtIndexCloud : function(id,src,width,height,conf,callback){
        'use strict';
        var container = document.querySelector("[data-uuid='"+id+"']");

        try {
            if (container) {
                container.dataset.imageid = conf.reserved_id;
                var image = container.querySelector('img.preview');
                var imgData = {};
                imgData.url = src;
                imgData.originalHeight = height;
                imgData.originalWidth = width;
                imgData.can_be_a_logo = conf.can_be_a_logo || false;
                imgData.type = conf.type || 'default';


                image.store('imageid', conf.reserved_id);
                image.store('ts_reorder', conf.ts_updated);
                image.store('data', imgData);
                Object.defineProperty(container, 'imageData', {
                    value: function () {
                        return imgData;
                    }
                });
                //console.warn('TYPE: ', conf);
                container.store('type', conf.type || 'default');
                container.setAttribute('title', (conf.original_name || id).replace(/"/gim, '/"'));
                image.url = src;
                image.addEventListener('load', function () {
                    /*if(container.querySelector(".loader")){
                        container.querySelector(".loader").style.display = "none";
                    }*/
                    container.classList.remove('loading');
                    this.checkForLoadingThumbs(container.parentNode, conf.type || 'default');

                    //if(!this.loadingQueue.length) console.warn('REMOVE “WAITING MINIATURES“');

                    //console.warn('AFTER LOAD ACTION IS: %s', conf.afterImportAction || 'none', this);
                    var maxWidth = 92, maxHeight = 69, mywidth, myheight, top;
                    var wRatio = maxWidth / width, hRatio = maxHeight / height;
                    var ratio = Math.min(wRatio, hRatio);
                    mywidth = width * ratio;
                    myheight = height * ratio;

                    top = Math.round((maxHeight - myheight) * 0.5);
                    var newImgStyle = {
                        'width': mywidth + 'px',
                        'height': myheight + 'px',
                        'margin-top': top + 'px'
                    };
                    Object.assign(image.style, newImgStyle);
                    image.style.display = 'block';
                    if (conf.afterImportAction === 'replace') {
                        this.userLayoutsImages = this.userLayoutsImages.map(function (img, pos) {

                            if (img.image_id === conf.reserved_id) {
                                console.warn(img, conf);
                                //console.warn('FOUND IMAGE TO SEND TO THE BOOK FOR AUTOIMPORT AT POSITION: %s', pos, img);
                                img.src = src.replace('thumbs', 'proxy');
                                imgData.src = img.src;
                                if (!img.already_imported) {
                                    img.already_imported = true;
                                    //this.layoutWaitingForImport[pos] = img;
                                    this.dispatch('auto:import:layout', img, (window.bookDef.bookElements.book + pos));
                                }

                            }
                            return img;
                        }.bind(this));
                    }
                }.bind(this));
                this.addImageEvents(image);
                if (!!(callback && callback.constructor && callback.call && callback.apply)) {
                    image.addEvent('load', callback);
                }
                image.src = src;
            }
        }catch(err){
            console.warn('ERROR:', err);
        }
    },
    addToLoadingQueue : function(el){
        'use strict';
        var _that = this,
            _next,
            _onComplete = function(){
                _that.loadedImages++;
                _that.loading -= 1 ;
                _that.loading = Math.max(_that.loading,0);
                _next = _that.loadingQueue.shift();
                if(_next){
                    _that.loading += 1;
                    _that.loadThumbImage(_next,_onComplete);
                }
                //TODO: controllare se l'istruzione seguente è corretta sempre!
                if(_that.loadedImages >= _that.userImages.length){ // ho messo maggiore uguale altrimenti le immagini appena uploadate non venivano
                    var els = document.getElements('.thumbnail .remove');
                    [].forEach.call(els, function (el) {
                        if(!el.parentNode.querySelector('.used_count').classList.contains('used_image'))
                            el.style.display = "block";
                    });
                   // window.___imagesAreReady = true;
                    //if(_that.onQueueEmpty) _that.onQueueEmpty();

                    if(!window.___imagesAreReady){
                        window.fireEvent('images:ready');
                        //window.dispatchEvent(new CustomEvent('images:ready'));
                    }
                    window.___imagesAreReady = true;
                    //window.dispatchEvent(new CustomEvent('images:ready'));
                }

                /*if(!_next) {
                    _that.dispatch('book:getallusedimages');
                    window.fireEvent('images:ready');
                }*/
        };
        if(_that.loading+1 <= _that.maxCuncurrent){
            _that.loading++;
            _that.loadThumbImage(el,_onComplete);
        } else {
            _that.loadingQueue.push(el);
        }
    },
    setUploadStatus : function(uuid,status, type){
        var total, thumbEl, tiEle;
        thumbEl = document.querySelector("[data-uuid='"+uuid+"']");
        thumbEl.dataset.image_status = status;
        //var type = thumbEl.retrieve('type');
        //console.warn('SET UPLOAD STATUS OF THE THUMB “%s“ TO %s FOR AN IMAGE OF TYPE %s ...THEN UPDATEING THE IMAGES GRAND TOTAL!', uuid, status, type);
        if(status == "upload_complete" && document.getElementById('total_images')){
            switch(type){
                case 'logos':
                    //console.warn(this.userLogoImages.length);
                    total = this.userLogoImages.length;
                    tiEle = document.getElementById('logos_total_images');
                    break;
                case 'layouts':
                    //console.warn(this.userLayoutsImages.length);
                    total = this.userLayoutsImages.length;
                    tiEle = document.getElementById('layouts_total_images');
                    break;
                default:
                    total = this.userImages.length;
                    tiEle = document.getElementById('total_images');
                    break;
            }
            tiEle.innerHTML = total;
        }
    },

    loadThumbImage : function(el,_callback){
        'use strict';
        //console.warn(el);
        var can_be_a_logo = false;

        if(el.original_name) {
            can_be_a_logo = (el.original_name.toLocaleString().match(/\.png$/) !== null);
        }else{

            this.userImages.some(function(img){
                if(img.uuid === el.uuid){
                    el.original_name = img.originalName;
                }
                return img.uuid === el.uuid;
            })
        }
        this.updateThumbnailAtIndexCloud(el.uuid,el.src,el.width, el.height , { reserved_id : el.image_id, can_be_a_logo: can_be_a_logo, type: el.type, afterImportAction: el.afterImportAction, original_name: el.original_name }, _callback);
    },
    loadInitialImagesCloud : function(order){
        'use strict';
        var self = this;
    },
    removeThumbnail : function(uuid){
        'use strict';
        var total, tiEle;
        var thumbEl = document.querySelector("[data-uuid='"+uuid+"']");


        var type = thumbEl ? thumbEl.retrieve('type') : null;
        if(!type && thumbEl && thumbEl.dataset.type) type = thumbEl.dataset.type;
        console.warn('REMOVING THE THUMB “%s“ OF TYPE: %s', uuid, type);
        switch(type){
            case 'layouts':
                this.userLayoutsImages = this.userLayoutsImages.filter(function(img){
                    if(img && img.uuid === uuid) return false;
                    return true;
                });
                total = this.userLayoutsImages.length;
                tiEle = document.getElementById('layouts_total_images');
                break;
            case 'logos':
                this.userLogoImages = this.userLogoImages.filter(function(img){
                    if(img && img.uuid === uuid) return false;
                    return true;
                });
                total = this.userLogoImages.length;
                tiEle = document.getElementById('logos_total_images');
                break;
            default:
                this.userImages = this.userImages.filter(function(img){
                    if(img && img.uuid === uuid) return false;
                    return true;
                });
                total = this.userImages.length;
                tiEle = document.getElementById('total_images');
                break;
        }
        if(tiEle) tiEle.innerHTML = total;
        if(thumbEl) thumbEl.parentNode.removeChild(thumbEl);
        //this.resize();
    },
    resize : function() {
        'use strict';
        if (getProduct() == "WALLART") return;
        var mainEl = this.options.thumbContainer;
        var childW = mainEl.firstElementChild ? parseInt(window.getComputedStyle(mainEl.firstElementChild).width) + 5 : 0;
        mainEl.style.width = childW * mainEl.childElementCount + 'px';
    },

    check4SpreadChanges: function(){

        if(!window.bookDef || !window.bookDef.bookElements) return;

        var max = 0;
        var offset = window.bookDef.bookElements.book;

        this.userLayoutsImages.map(function(img, pos){
            var p = offset + pos;
            if(!img.already_imported && p > max) max = p;
        });
        if(max >= (window.bookDef.spreads.length-1)){
            console.warn('FOUND A NEW SPREAD MAX: %s', max);
            this.dispatch('add:layout:pages', {'pos': max, 'last': (window.bookDef.spreads.length - 2)});
        }
    },

    onUploadComplete: function(type){
        var max = 0;
        var offset = window.bookDef.bookElements.book;
        var toAdd = [];

        console.warn('UPLOAD TASK COMPLETE. TYPE WAS: %s', type);
        switch(type){
            case 'layouts':

                break;
        }
    },

    importImagesOnLayout: function(selected_list, layout){
        var self = this, list = [], pos = -1;
        //console.warn('layout', layout);

        return Promise.all(Array.prototype.map.call(selected_list, function(el, pos){
            var lay, page, img = el.imageData();
            img.src = img.url.replace('thumbs','proxy');
            img.path = img.src;
            lay = layout;
            //page = pos;
            if(layout === 'single') {
                lay = pos%2 === 0 ? 'single-sx' : 'single-dx';
                page = parseInt(pos/2);
                console.warn('PAGE: %s (ARRAY POS: %s), LAYOUT: %s', page, pos, lay);
            }else{
                page = pos;
            }

            return new Promise(function(fullfill, reject){
                window.setTimeout(function(){
                    window.requestAnimationFrame(function(){
                        //console.warn(page, lay);
                        el.classList.remove('selected');
                        if(window.bookDef.bookElements.book + page < window.bookDef.spreads.length) {
                            self.dispatch('auto:import:layout', img, (window.bookDef.bookElements.book + page), lay, true);
                        }
                        fullfill();
                    });
                }, (pos*300));
            });

        }))
    },

    executeFilterCommand: function(cmd, val){
        console.warn('EXECUTE COMMAND: %s', cmd);
        var n1,n2,file1, file2, d,filtered, selected_list, tmpl, tmpl2, el;
        switch(cmd){
            case 'order_by_name':
                console.debug('ORDER FILES BY: %s', val);
                if(val){
                    filtered = this.userImages.map(function(i){
                        return i;
                    });
                    filtered.sort(function(a, b){
                        file1 = (a.original_name || a.originalName).toLowerCase();
                        file2 = (b.original_name || b.originalName).toLowerCase();
                        //console.warn('Ordering: "%s" and "%s"', file1,file2);
                        n1 = /[-|_](\d+)(?!.*\d)\s*\.\w+$/ig.exec(file1);
                        n2 = /[-|_](\d+)(?!.*\d)\s*\.\w+/ig.exec(file2);

                        if(n1) n1 = Number(n1[0]);
                        if(n2) n2 = Number(n2[0]);

                        if(n1 && n2){
                            console.warn('ORDER BY NUMBERS: %s, %s',n1,n2);
                            if(n1 < n2) return -1;
                            if(n1 > n2) return 1;
                            return 0;
                        }
                        console.warn('USING STRING COMPARISON %s, %s', file1, file2);
                        if(file1 < file2) return -1;
                        if(file1 > file2) return 1;
                        return 0;
                    });
                }else{
                    filtered =  this.userImages;
                }
                break;

            case 'import_photos':

                selected_list = document.querySelectorAll('#pagePhotos .thumbnail.selected');
                if(!selected_list.length) selected_list = document.querySelectorAll('#pagePhotos .thumbnail');
                if(!selected_list || selected_list.length < 1) return;
                tmpl = document.querySelector('#importImagesTemplate');
                tmpl2 = document.querySelector('#importImagesTemplateProgress');
                tmpl = tmpl.content.cloneNode(true);
                el = document.createElement('div');
                el.className = 'import-images-alert';
                el.appendChild(tmpl);
                el.querySelector('.how-many').innerText = selected_list.length+' immagini';
                swal({
                    content: el,
                    dangerMode: false,
                    closeOnClickOutside: true,
                    closeOnEsc: true,
                    buttons: {
                        cancel: 'Annulla',
                        ok: {
                            text: 'Importa',
                            value: 'import',
                            closeModal: false,
                        }
                    }
                })
                .then(function(val){
                    if(!val) throw null;
                    el.classList.add('running');
                    var opt = 'double';
                    var opts = el.querySelectorAll('input[type="radio"]');
                    Array.prototype.some.call(opts, function(el){
                        if(el.checked) opt = el.value;
                        return el.checked;
                    });
                    el.innerHTML = '';
                    el.appendChild(tmpl2.content.cloneNode(true));
                    swal({
                        content: el,
                        dangerMode: false,
                        closeOnClickOutside: false,
                        closeOnEsc: false,
                        buttons: false
                    });

                    return this.importImagesOnLayout(selected_list, opt);
                }.bind(this))
                .then(function(p){
                    swal({icon: 'success', title: 'Importazione avvenuta con successo', 'text': 'Tutte le immagini sono state importate nell\'impaginato' });
                });

            break;

            case 'import_photos_advanced':
                if(val){
                    var spreads = [];
                    if(window.bookDef) {
                        console.warn('CHECK SPREADS', spreads);
                        window.bookDef.spreads.map(function (ele, i) {
                            if (!ele) return;
                            if (['single', 'double'].indexOf(ele.type) === -1) return;
                            spreads.push(i);
                        });
                        console.warn('SPREADS', spreads);
                    }
                    this.fireEvent('update:spreads');
                    this.spreads = spreads;
                    document.body.classList.add('importing-images');
                }else{
                    document.body.classList.remove('importing-images');
                }
                break;

            default:
                console.warn('COMMAND NOT FOUND: %s', cmd);
        }

        if(filtered){
            window.requestAnimationFrame(function(){
                filtered.map(function(el,i){
                    d = document.querySelector('[data-uuid="'+el.uuid+'"]');
                    if(!d) return;
                    d.dataset.importIn = i;
                    d.parentNode.appendChild(d);
                });
                filtered = null;
            });
        }
    },

    initializeThumbnailsCommands: function(){

        var cmds = document.body.querySelectorAll('#pagePhotos [data-cmd]');

        Array.prototype.map.call(cmds, function(el){
            var cmd = el.getAttribute('data-cmd');
            var active = false;
            el.addEventListener('change', function(e){
                e.stopPropagation();
                el.classList[el.checked ? 'add' : 'remove']('active');
                //active = !active;
                this.executeFilterCommand(cmd, el.checked);
            }.bind(this))
        }.bind(this))
    }
});